const loggger = {
	log: function (msg: String) {
		console.log(msg);
	},
};
export default loggger;
